export default __webpack_public_path__ + "static/media/image-study-board-2-m.f84ce375.webp";